import { Link } from '../router';
import { solutions } from '../content';

/**
 * §4.1 Solutions: Distribution & Trading, Industrial Sales, Wholesale & Warehousing, and
 * Professional Services.
 *
 * A solution is only listed once the applications behind it are sellable — the warehousing one
 * arrived with Inventory, not before it.
 */
export default function Solutions({ navigate }: { navigate: (to: string) => void }) {
  return (
    <>
      <section className="section">
        <div className="wrap">
          <div className="section__head">
            <span className="eyebrow">Solutions</span>
            <h1 style={{ marginBottom: 16 }}>Configured for how your industry actually sells</h1>
            <p>
              The same platform, set up differently. Terminology, fields, approval routes and
              dashboards follow the trade rather than forcing it into a generic shape. Further
              industry packs follow these three.
            </p>
          </div>

          <div className="grid" style={{ gap: 20 }}>
            {solutions.map((solution) => (
              <article key={solution.name} className="card">
                <div
                  className="grid grid--2"
                  style={{ gap: 32, alignItems: 'start', gridTemplateColumns: '1fr 1fr' }}
                >
                  <div>
                    <h2 style={{ fontSize: '1.4rem', marginBottom: 10 }}>{solution.name}</h2>
                    <p>{solution.body}</p>
                  </div>

                  <ul className="ticks">
                    {solution.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--sunken">
        <div className="wrap">
          <div className="section__head">
            <span className="eyebrow">Configuration</span>
            <h2>Changed by an administrator, not by a developer</h2>
            <p>
              Fields, forms, layouts, workflows, templates, terminology, dashboards and permissions
              are configuration. Where a customer genuinely needs code — a connector, a bespoke
              workflow — it is governed and quoted separately rather than bolted on.
            </p>
          </div>

          <div className="grid grid--3">
            <article className="card card--flat">
              <h3>Country aware</h3>
              <p>
                Currency, time zone, language, date format, tax, holidays and statutory options
                follow the country a company operates in.
              </p>
            </article>
            <article className="card card--flat">
              <h3>Multi-company</h3>
              <p>
                Several legal entities inside one tenant, each with its own numbering, branches and
                departments — and users who see only what they should.
              </p>
            </article>
            <article className="card card--flat">
              <h3>Migration</h3>
              <p>
                Import from spreadsheets or an existing system, with validation you can review
                before anything is written.
              </p>
            </article>
          </div>

          <p style={{ marginTop: 28 }}>
            <Link to="/pricing" onNavigate={navigate}>
              See pricing →
            </Link>
          </p>
        </div>
      </section>
    </>
  );
}
